import { Router } from '@angular/router';
import { AuthService } from './../../../../services/auth.service';
import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {KahpooReverseService} from "../../../../services/kahpooreverse.service";
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-seller',
  templateUrl: './seller.component.html',
  styleUrls: ['./seller.component.scss']
})
export class SellerComponent implements OnInit {
  @ViewChild('closebutton') closebutton;

  data = [];

  sorted1 = false;
  sorted2 = false;
  sorted3 = false;
  sorted4 = false;
  sorted5 = false;
  /*
-----------------------------         for all page attribute    --------------------------------
*/
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 15, 30, 50];
  search: any;
  perPage = 10;

  constructor(private kahpooReverseService: KahpooReverseService, private authService: AuthService,
              private router: Router) { }

  ngOnInit(): void {
    this.authService.isAuthenticated().subscribe(isAuthenticated => {
      this.loadVendeurs();
    },error=>{
      this.router.navigate(['/login']);
    });
  }

  onCheckboxClick(selectCheckBoxArr) {
    alert(JSON.stringify(selectCheckBoxArr));
  }


  private loadVendeurs() {
    this.kahpooReverseService.getAllSeller().subscribe(dt => {
      // console.log("Liste des vandeurs...");
      // console.log(dt);
      this.data = dt;
    })
  }

  close() {
    this.closebutton.nativeElement.click();
  }

  selectSellerReversement(row: any) {
   // console.log(row)
    localStorage.setItem('currentSeller', JSON.stringify(row));
  }

  exportexcel(fileName): void
  {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName);

  }


  /*
   -----------------------------          for all page methodes      -----------------------------
    */


  searchFilter($event: KeyboardEvent) {
    this.kahpooReverseService.getAllSeller().subscribe(dt => {
      this.data = dt;
      this.data = this.data.filter(value =>
        value?.username?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.phoneNumber?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.email?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.residenceCity?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.residenceCountry?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.firstname?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.lastname?.toLowerCase().includes(this.search.toUpperCase())
      );

    }, (err) => {
     // console.log('-----> err', err);
    });
  }

  displayPerPage(value: any) {
    this.perPage = parseInt(value, 10);
   // console.log(this.tableSize);
  }
  /*
  end for all page
   */

  sort1() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.data.sort((a, b) => a.username > b.username ? 1 : a.username < b.username ? -1 : 0)
      this.sorted1 = true;

    } else {
      // @ts-ignore
      this.data.sort((a, b) => a.username < b.username ? 1 : a.username > b.username ? -1 : 0)
      this.sorted1 = false;

    }
  }
  sort2() {
    if(this.sorted2 == false) {
      // @ts-ignore
      this.data.sort((a, b) => a.lastname  > b.lastname ? 1 : a.lastname < b.lastname ? -1 : 0)
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.data.sort((a, b) => a.lastname  < b.lastname  ? 1 : a.lastname > b.lastname ? -1 : 0)
      this.sorted2 = false;
    }
  }
  sort3() {
    if(this.sorted3 == false) {
      // @ts-ignore
      this.data.sort((a, b) => a.firstname > b.firstname ? 1 : a.firstname < b.firstname ? -1 : 0)
      this.sorted3 = true;
    } else {
      // @ts-ignore
      this.data.sort((a, b) => a.firstname < b.firstname ? 1 : a.firstname > b.firstname ? -1 : 0)
      this.sorted3 = false;
    }
  }
  sort4() {
    if(this.sorted4 == false) {
      // @ts-ignore
      this.data.sort((a, b) => a.email > b.email ? 1 : a.email < b.email ? -1 : 0)
      this.sorted4 = true;
    } else {
      // @ts-ignore
      this.data.sort((a, b) => a.email < b.email ? 1 : a.email > b.email ? -1 : 0)
      this.sorted4 = false;
    }
  }
  sort5() {
    if(this.sorted5 == false) {
      // @ts-ignore
      this.data.sort((a, b) => a.phoneNumber > b.phoneNumber ? 1 : a.phoneNumber < b.phoneNumber ? -1 : 0)
      this.sorted5 = true;
    } else {
      // @ts-ignore
      this.data.sort((a, b) => a.phoneNumber < b.phoneNumber ? 1 : a.phoneNumber > b.phoneNumber ? -1 : 0)
      this.sorted5 = false;
    }
  }
}
